module.exports = __webpack_public_path__ + "static/media/img_04_xs.4146c885.jpg";